/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDashboardVerificationFromDiscriminatorValue, type DashboardVerification } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard/GetVerifications
 */
export interface GetVerificationsRequestBuilder extends BaseRequestBuilder<GetVerificationsRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DashboardVerification[]>}
     */
     get(requestConfiguration?: RequestConfiguration<GetVerificationsRequestBuilderGetQueryParameters> | undefined) : Promise<DashboardVerification[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<GetVerificationsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface GetVerificationsRequestBuilderGetQueryParameters {
    dashboardBookingId?: number;
}
/**
 * Uri template for the request builder.
 */
export const GetVerificationsRequestBuilderUriTemplate = "{+baseurl}/Dashboard/GetVerifications?dashboardBookingId={dashboardBookingId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetVerificationsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: GetVerificationsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createDashboardVerificationFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
